import {useState} from "react";
import {
  Container,
  Drawer
} from "@mui/material";

export function useDealPageDrawer() {
  const [drawerState, setDrawerState] = useState(false);
  const [content, setContent] = useState(null);
  const [onCloseCb, setOnCloseCb] = useState(null);

  const toggleDrawer = (open, drawerContent = null, callback = null) => (event) => {
    if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setContent(drawerContent);
    setOnCloseCb(() => callback);
    setDrawerState(open);
  };

  const onDrawerClose = () => {
    if (onCloseCb) onCloseCb();
    setDrawerState(false);
  };

  const closeDealDrawer = () => setDrawerState(false);

  const DrawerComponent = () => (
    <Drawer
      open={drawerState}
      anchor="right"
      ModalProps={{
        onBackdropClick: onDrawerClose
      }}
    >
      <Container sx={{ width: 600, padding: 1 }}>
        {content}
      </Container>
    </Drawer>
  );

  return { DrawerComponent, toggleDrawer, onDrawerClose, closeDealDrawer};
}